import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ConfigService } from '@hohr/config';
import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { MyCvFeatureFlags } from '@app/features/my-cvs/data-structures/my-cvs-feature-flags.interface';

@Injectable({ providedIn: 'root' })
export class CanCreateCVGuard implements CanActivate {

    private myCvFeatureFlags = MyCvFeatureFlags;
    constructor(
        private configService: ConfigService,
        private router: Router
    ) { }

    canActivate() {
        return this.configService.checkFeatureFlag(this.myCvFeatureFlags.MyCvHasCreateModule).pipe(
            mergeMap(result => result ? of(true) : this.router.navigate(['my-cvs']))
        );
    }
}
